import React from "react";
import classes from "./Login.module.scss";
import emailIcon from "../../../lib/images/email.png";
import clsx from "clsx";

const EmailVerification = () => {
  return (
    <div className={clsx(classes.verification, "container mt-3 text-center")}>
      <div>
        <div className="row">
          <div className="col">
            <div className="row mt-2 ">
              <div className="col mt-5">
                <img src={emailIcon} alt="Email verification" width={100} />
              </div>
            </div>
            <div className="row mt-2 ">
              <div className="col mt-5">
                <h3>Verify your email address</h3>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col"></div>
              <div className="col-md-6">
                We've sent an email to your registered email id to verify your
                account. Just click the link in that email to complete the
                sign-up process.
                <hr></hr>
              </div>
              <div className="col"></div>
            </div>
          </div>

          <div className="col">
            <img src="/login.svg" alt="" style={{ opacity: 0.3 }}></img>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;
